import React, { FC } from "react";
import { FormattedMessage } from "react-intl";

import CompanyForm from "./CompanyForm";
import RegistrationHeading from "./RegistrationHeading";

// import style from "./CompanyStep.module.scss";

export const CompanyStep: FC = () => (
  <>
    <RegistrationHeading />
    <main>
      <h2>
        <FormattedMessage id="register.companyInfo" />
      </h2>
      <CompanyForm />
    </main>
  </>
);
